import React from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TitleText from '../TitleText';
import { Image } from 'components/atoms';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import Autoplay from '../Autoplay';
import Navigation from '../Navigation';

const useStyles = makeStyles(theme => ({
    PopularAlbumsRoot: {
        width: '100%',
        height: '100%',
        zIndex: 'auto',
        position: "relative",
        overflow: "hidden",
        marginBottom: "50px",
        "& .swiper-image": {
            width: "90%",
            height: "300px",
            transition: ".5s",
            position: "relative",
            [theme.breakpoints.up('md')]: {
                height: "300px",
            },
        },
        "& .swiper-button": {
            position: 'absolute',
            bottom: '5%',
            left: '0',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            opacity: 0,
            transition: ".8s",
            textTransform: "uppercase",
            "& .swiper-button-left": {
                width: "40%",
                background: "#7E53F9",
                color: "#fff",
                padding: "10px 5px",
                marginRight: "5px",
                textAlign: "center",
                display: "none",
                [theme.breakpoints.up('md')]: {
                    display: "block"
                },
            },
            "& .swiper-button-right": {
                width: "40%",
                color: "#000",
                padding: "10px 5px",
                background: "#fff",
                marginLeft: "5px",
                textAlign: "center",
                display: "none",
                [theme.breakpoints.up('md')]: {
                    display: "block"
                },
            },
        },
        "& .swiper-slide-active": {
            height: "400px",
            paddingBottom: 0,
            transition: ".5s",
            [theme.breakpoints.up('md')]: {
                height: "500px",
            },
            "& .swiper-image": {
                transition: ".5s",
                height: "300px",
                [theme.breakpoints.up('md')]: {
                    height: "400px",
                },
            },
            "& .swiper-button": {
                opacity: 1,
                transition: ".8s",
            }
        },
        '& .swiper-button-prev, & .swiper-button-next': {
            width: theme.spacing(3),
            height: theme.spacing(3),
            padding: theme.spacing(2),
            background: theme.palette.primary.main,
            borderRadius: '100%',
            position: 'absolute',
            zIndex:1000,
            boxShadow: `0 2px 10px 0 ${theme.palette.cardShadow}`,
            border: `2px solid ${theme.palette.background.paper}`,
            '&:after': {
                fontSize: 'initial',
                color: theme.palette.background.paper,
            },
        },
        '& .swiper-button-prev': {
            left: "-250px",
            right: 0,
            top: 0,
            bottom: "180px",
            margin: "auto",
            [theme.breakpoints.up('md')]: {
                bottom: "80px",
            },
        },
        '& .swiper-button-next': {
            right: "-250px",
            left: 0,
            top: 0,
            bottom: "180px",
            margin: "auto",
            [theme.breakpoints.up('md')]: {
                bottom: "80px",
            },
        },
    },
    swiperSlide: {
        width: 'auto',
        height: "400px",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column",
        transition: ".5s",
        [theme.breakpoints.up('sm')]: {
        },
        [theme.breakpoints.up('md')]: {
            height: "500px",
        },
    },
    image: {
        objectFit: 'cover',
    },
    typography: {
        textAlign: "center",
        fontFamily: "Basic",
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "30px",
        textTransform: "uppercase",
        color: "#000",
        [theme.breakpoints.up('md')]: {
            fontSize: "24px",
        },
    },
    typography1: {
        textAlign: "center",
        fontFamily: "Basic",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "40px",
        textTransform: "uppercase",
        color: "#4F4F4F",
        [theme.breakpoints.up('md')]: {
            fontSize: "18px",
        },
    },
    swiperNav1: {
        display: 'flex',
        justifyContent: 'space-between',
        position: 'absolute',
        top: '40%',
        bottom: '0',
        left: '0',
        right: '0',
        margin: '0 auto',
        width: 88,
        // bottom: theme.spacing(2),
        // right: theme.spacing(2),
        zIndex: 4,
        [theme.breakpoints.up('md')]: {
            margin: '0 auto',
            top: '50%',
        },

    },
    swiperButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column",
        [theme.breakpoints.up('md')]: {
            display: "none"
        },
        "& div": {
            width: "50%",
            color: "#000",
            padding: "15px",
            textAlign: "center",
            border: "1px solid #9B9B9B",
            marginTop: "20px",
            fontSize: "14px",
            [theme.breakpoints.up('md')]: {
                width: "30%",
            },
        },
    }
}));

const PopularAlbums = (props) => {
    const classes = useStyles();
    const PopularAlbumsData = useSelector((state) => state.cover.discovers?.top_albums?.data);

    return (
        <div className={classes.PopularAlbumsRoot}>
            <TitleText text={"Popular Albums (Top 10)"} />

            <Swiper
                slidesPerView={'auto'}
                spaceBetween={0}
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                centeredSlides={true}
                breakpoints={{
                    320: {
                        slidesPerView: 1.5,
                    },
                    990: {
                        slidesPerView: 2,
                    },
                    1350: {
                        slidesPerView: 4,
                    }
                }}
                navigation={true}
                modules={[Autoplay, Navigation]}
            >
                {PopularAlbumsData && PopularAlbumsData.map((item, index) => (
                    <SwiperSlide
                        className={clsx(
                            'swiper-image__slide',
                            'swiper-slide',
                            classes.swiperSlide,
                        )}
                        key={index}
                    >
                        <div className={"swiper-image"}>
                            <Image
                                src={item.image}
                                alt={item.image}
                                srcSet={item.image}
                                lazyProps={{ width: '100%', height: '100%' }}
                                className={clsx(
                                    'swiper-image__item',
                                    classes.image,
                                )}
                            />
                            <div className={"swiper-button"}>
                                <div className={"swiper-button-left"}>
                                    listen to album
                                </div>
                                <div className={"swiper-button-right"}>
                                    artist profile
                                </div>
                            </div>
                        </div>

                        <Typography className={classes.typography1}>
                            {item.title}
                        </Typography>
                        <Typography className={classes.typography}>
                            {item.artistName}
                        </Typography>
                    </SwiperSlide>
                ))}
                <div className={classes.swiperButton}>
                    <div>
                        LISTEN ALBUM
                    </div>
                    <div>
                        BUT NOW
                    </div>
                </div>
            </Swiper>
        </div >
    )
}


PopularAlbums.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};


export default PopularAlbums
